import { render } from "./page-bar.vue?vue&type=template&id=4b306886&scoped=true"
import script from "./page-bar.vue?vue&type=script&lang=js"
export * from "./page-bar.vue?vue&type=script&lang=js"

import "./page-bar.vue?vue&type=style&index=0&id=4b306886&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\67026\\Desktop\\front1.0\\front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b306886"]])

export default __exports__
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPageSticky,QToolbar,QTabs,QTab,QIcon,QTooltip});
